<!-- 登录页 -->
<template>
  <div class='loginTrue'>
    <div class="wrapTrue">
      
      <div class="Hseat"></div>
      <div class="inputFormTrue">
        <div class="telDivTrue">
          <i class="iconfont iconiconfontshouji"></i>
          <input type="text" placeholder="请输入手机号">
        </div>
        <div class="clearBoth"></div>
        <div class="telDivTrue">
          <i class="iconfont iconsuo"></i>
          <input class="pswWidthTrue" type="text" placeholder="请输入验证码">
          <button>获取验证码</button>
        </div>
      <div class="Hseat"></div>
</div>
      <div class="loginBtnTrue" @click="login">登录</div>
      <div class="agremmentTrue">
        <span class="leftRouter">卡绑定登录</span>
        <span class="rightRouter">收不到验证码</span>
      </div>
    </div>
     
  </div>
</template>

<script>
 import * as api from '@/api'
 import { mapMutations } from 'vuex';
  export default {
    name: 'login',
    data () {
      return {
       docslist:'',
       token:'',
      }
    },
    components: {
      
    },
    computed: {
   
    },
    mounted: function () {
      this.workexp();
    },
    methods: {
      ...mapMutations(['changeLogin']),
        // 点击登录
        async login(){
          let _this = this;
          try{
            const {code,data,message} = await api.user.login('18614567895','123123qwe')
      
            if(code === 200){
              this.docslist = data;
              _this.token = data.token;
              
             _this.changeLogin({ reToken:_this.token });// 将用户token保存到vuex中
             _this.$router.push('/');
              
            }else{
              // HyrToast(submsg || msg)
            }
          }catch(err){
            console.log(err)
          }
        },
  
         async workexp(){
          try{
            const {code,data,message} = await api.user.workexp()
      
            if(code === 200){
              this.docslist = data
              console.log(this.docslist)
            }else{
              // HyrToast(submsg || msg)
            }
          }catch(err){
            console.log(err)
          }
        },
  
    },
   
  }
</script>

<style lang="stylus">
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'
.wrapTrue
   width 100%
   height 100%
  .headWrap
   height 88px
   line-height 88px
   font-size 36px
   color #262626
   display flex
   width calc(100% - 48px);
   margin 0 auto

   span
    flex 1
   span:nth-child(1) img
    width 22px
    height 38px
    vertical-align middle
   span:nth-child(2)
    text-align center
    
.HseatTrue
  height 129px

.telDivTrue
  width calc(100% - 150px)
  margin 15px auto
  height 80px
  border-bottom 1px solid #ddd
  i 
    font-style normal
    margin-top 15px
    float left
  input 
    width calc(100% - 90px)
    height 66px
    font-size 30px
    margin-left 20px
  button 
     border 2px solid $codeColor
     width 180px
     height 66px
     font-size 28px
     background $codeColor
     color black
     float right
     cursor pointer
  .pswWidth
     width 300px!important
     display inline

.loginBtnTrue
  width calc(100% - 150px)
  height 90px
  line-height 90px
  margin 0 auto
  background $background
  border-radius 45px
  font-size 34px
  text-align center
  color:$color
  cursor pointer

.agremmentTrue
  width calc(100% - 224px)  
  margin 32px auto
  font-size 24px
  span 
   cursor pointer
.clearBoth
  clear both  
.leftRouter
  float $floLeft
.rightRouter
  float $florRight  
.loginTrue
  background #fff   
  height 100% 
</style>



// WEBPACK FOOTER //
// src/view/login/index.vue